import moment from 'moment';
import {
  Button,
  Select,
  DatePicker,
} from 'antd';
import React, { Component } from 'react';
import i18n from '../../config/i18n';
import connectActionsAndReducers from '../../toolbox/connectActionsAndReducers';
import ActivityLogAPIConnectors from '../../api/ActivityLogAPIConnectors';
import LoadingIcon from '../../components/shared/LoadingIcon';

const styles = {
  thead: {
    backgroundColor: '#607484', color: '#FFF',
  },
  marginLeft: { marginLeft: 10 },
  fullWidth: { width: '100%' },
  flexRow: { display: 'flex', flexDirection: 'row' },
  minWidth: { minWidth: 40 },
};

// display name: regex pattern
const categoryList = {
  'View Medical Record': 'view medical record',
  'Log In': 'logged in',
  'Log Out': 'logged out',
  'View Patient List': 'view patient list',
  Televisit: 'video chat',
  'Create Assessment': 'create.*assessment',
  'View Assessment': 'view.*assessment',
  'Update Assessment': 'update.*assessment',
  'Remove Assessment': 'remove.*assessment',
  Export: 'export',
};
const defaultStartDate = moment().subtract(30, 'days').startOf('day');
const defaultEndDate = moment().endOf('day');

class ActivityLogContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: moment().subtract(30, 'days').startOf('day'),
      endDate: moment().endOf('day'),
      filter: { where: {} },
      selectedCategories: Object.keys(categoryList),
    };
  }

  componentDidMount() {
    const actions = this.props.actions;
    actions.onFetchActivityLogPending();
    this.applyFilter();
  }

  getCategories = () => {
    const { Option } = Select;
    return Object.keys(categoryList).map(el => (<Option key={el}>{el}</Option>));
  };

  setCategory = (selectedCategories) => {
    this.setState({ selectedCategories });
  };

  prepareLogLoadingHtml() {
    return (
      <tr>
        <td><LoadingIcon /></td>
        <td />
        <td />
        <td />
      </tr>
    );
  }

  prepareLogsListHtml(log, index) {
    return (
      <tr key={log.id}>
        <td>{index + 1}</td>
        <td>
          {
            // No userId means it is a system log.
            log.userId
              ? log.users.email
              : 'System'
          }
        </td>
        <td>
          {log.action}
        </td>
        <td>{moment(log.created).format('YYYY-MM-DD hh:mm:ss A')}</td>
      </tr>
    );
  }

  prepareLogsHtml() {
    if (this.props.log.isLoading) {
      return this.prepareLogLoadingHtml();
    }
    // Here we don't need to worry about `this.props.log.logs === 0`
    // since when user goes to the logs page, they have to log in first.
    // There will be at least one log.
    return this.props.log.logs.map((log, index) => this.prepareLogsListHtml(log, index));
  }

  applyFilter = () => {
    const { actions } = this.props;
    const {
      startDate,
      endDate,
      selectedCategories,
    } = this.state;
    const filter = {
      where: {
        created: {
          between: [
            startDate.format('YYYY-MM-DD hh:mm:ss A'),
            endDate.format('YYYY-MM-DD hh:mm:ss A'),
          ],
        },
      },
    };
    if (selectedCategories.length) {
      filter.where.action = {};
      filter.where.action.regexp = `/.*(${selectedCategories.map(el => categoryList[el]).join('|')}).*/i`;
    }
    ActivityLogAPIConnectors.getLogsByFilter(filter)
      .then((data) => {
        actions.onFetchActivityLogSucceeded(data);
      }).catch((err) => {
        actions.createDangerAlert(err.message);
      });
  };

  clearFilter = () => {
    this.setState({
      startDate: moment().subtract(30, 'days').startOf('day'),
      endDate: moment().endOf('day'),
      filter: { where: {} },
      selectedCategories: [],
    }, () => this.applyFilter());
  }

  resetFilter = () => {
    this.setState({
      startDate: moment().subtract(30, 'days').startOf('day'),
      endDate: moment().endOf('day'),
      filter: { where: {} },
      selectedCategories: Object.keys(categoryList),
    }, () => this.applyFilter());
  }

  render() {
    const {
      selectedCategories,
      startDate,
      endDate,
    } = this.state;
    this.logsHtml = this.prepareLogsHtml();
    return (
      <div className="row">
        <div className="col-md-12">
          {/*
           the search bar and pagination are not really working now
           since we don't have page information along
           with patient list, if you don't want to show them, just hide them
           */}
          <h1>
            {i18n.t('activityLogs')}
          </h1>
          <p className="lead">
            {i18n.t('viewYourActivityLogs')}
          </p>
          <hr />
          <div>
            <div style={styles.flexRow}>
              <div style={styles.minWidth}>{`${i18n.t('categories')}: `} </div>
              <div style={{ ...styles.marginLeft, ...styles.fullWidth }}>
                <Select
                  mode="multiple"
                  style={styles.fullWidth}
                  placeholder={i18n.t('pleaseSelect')}
                  value={selectedCategories}
                  onChange={this.setCategory}
                >
                  {this.getCategories()}
                </Select>
              </div>
            </div>
            <br />
            <div style={styles.flexRow}>
              <div>
                <span>{`${i18n.t('startDate')}: `}</span>
                <DatePicker
                  value={startDate}
                  disabledDate={date => date > endDate}
                  allowClear={false}
                  onChange={(date) => {
                    this.setState({ startDate: date ? date.startOf() : defaultStartDate });
                  }}
                />
              </div>
              <div style={styles.marginLeft}>
                <span>{`${i18n.t('endDate')}: `}</span>
                <DatePicker
                  value={endDate}
                  disabledDate={date => date && (date > moment().endOf('day') || date < startDate)}
                  allowClear={false}
                  onChange={(date) => {
                    this.setState({
                      endDate: date ? date.endOf() : defaultEndDate });
                  }}
                />
              </div>
            </div>
            <br />
            <div style={{
              ...styles.flexRow,
              float: 'right',
              marginBottom: 20,
            }}
            >
              <div style={styles.marginLeft}>
                <Button onClick={this.applyFilter}>{i18n.t('applyFilter')}</Button>
              </div>
              <div style={styles.marginLeft}>
                <Button onClick={this.clearFilter}>{i18n.t('clearFilter')}</Button>
              </div>
              <div style={styles.marginLeft}>
                <Button onClick={this.resetFilter}>{i18n.t('resetFilter')}</Button>
              </div>
            </div>
          </div>
          <br />
          <div>
            <table className="table table-striped table-hover table-responsive ActivityLog">
              <thead style={styles.thead}>
                <tr>
                  <th>#</th>
                  <th>{i18n.t('user')}</th>
                  <th>{i18n.t('actions')}</th>
                  <th>{i18n.t('Timestamp')}</th>
                </tr>
              </thead>
              <tbody>
                {this.logsHtml}
              </tbody>
            </table>
          </div>
        </div>
      </div >
    );
  }
}

export default connectActionsAndReducers(ActivityLogContainer);



// WEBPACK FOOTER //
// ./src/containers/activity/ActivityLogContainer.js